import { ref, type Ref, onMounted } from 'vue'
import { sdk } from '@/graphql/client'
import type { AdminLookupDevicesQuery } from '@/graphql/generated/sdk'

type RawDevice = NonNullable<
    NonNullable<
        NonNullable<AdminLookupDevicesQuery['admin']>['device']
    >['list']
>[number]

export interface DeviceOption {
    id: string  // "d-<id>" prefix for backend stats contract
    name: string
}

export function useDeviceOptions() {
    const options: Ref<DeviceOption[]> = ref([])

    async function load() {
        try {
            const r = await sdk.AdminLookupDevices()
            const list = r.admin?.device?.list ?? []
            options.value = (list as RawDevice[])
                .filter((d): d is NonNullable<RawDevice> => d !== null)
                .map(d => ({
                    id: `d-${d.id}`,
                    name: d.name || d.username || `Device ${d.id}`
                }))
        } catch {
            options.value = []
        }
    }

    onMounted(load)
    return options
}
